module.exports = __webpack_public_path__ + "img/contentinfo2.0a7bc4a9.png";